import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '../../src/assets/images/club-master.png';
import _imports_1 from '../../src/assets/images/is-top.png';
var _hoisted_1 = {
  class: "author--pic img--wrapper"
};
var _hoisted_2 = ["src", "alt"];
var _hoisted_3 = ["alt"];
var _hoisted_4 = {
  class: "author_type img--wrapper"
};
var _hoisted_5 = {
  key: 0,
  src: "//www.d1ev.com/static/home/search/images/author-tip-1.png",
  alt: ""
};
var _hoisted_6 = {
  key: 1,
  src: "//www.d1ev.com/static/home/search/images/author-tip-2.png",
  alt: ""
};
var _hoisted_7 = {
  class: "author-info"
};
var _hoisted_8 = {
  class: "info-wrapper"
};
var _hoisted_9 = {
  class: "info-name"
};
var _hoisted_10 = {
  key: 0,
  class: "level"
};
var _hoisted_11 = {
  key: 1,
  class: "club-master img--wrapper"
};

var _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1);

var _hoisted_13 = [_hoisted_12];
var _hoisted_14 = {
  key: 1,
  class: "isTop"
};

var _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1);

var _hoisted_16 = /*#__PURE__*/_createTextVNode("置顶");

var _hoisted_17 = [_hoisted_15, _hoisted_16];
var _hoisted_18 = {
  key: 0,
  class: "info_tip"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "li_author",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.onClickUser && $options.onClickUser.apply($options, arguments);
    })
  }, [_createElementVNode("div", _hoisted_1, [$options.authorImage ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $options.authorImage,
    alt: $props.nickName
  }, null, 8, _hoisted_2)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: "//d1ev.com/special/player/images/logo-d1ev-app.png",
    class: "image-default",
    alt: $props.nickName
  }, null, 8, _hoisted_3)), _createElementVNode("div", _hoisted_4, [$options.userTypeToString === '1' ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : $options.userTypeToString === '2' || $options.userTypeToString === '3' || $options.userTypeToString === '4' ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString($options.checkedNickName), 1), $props.isClub ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$props.level ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($props.level), 1)) : _createCommentVNode("", true), $props.isCircleLandlord ? (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_13)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), $props.isTop === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_17)) : _createCommentVNode("", true)]), $props.tags ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString($props.tags), 1)) : _createCommentVNode("", true)])]);
}